
import { Vue, Component } from 'vue-property-decorator';
import { Popup } from 'vant';
Vue.use(Popup);
@Component
export default class Rule extends Vue {
  show: boolean = false;
  showPopup(value: any) {
    this.show = true;
  }
}
